export default __webpack_public_path__ + "static/media/le_touquet11.72a9bdab.jpg";